import NotificationComponent from './Notification'
import { ToastProps } from './types'

let notificationInstance: NotificationComponent | undefined
const pendingMessages: ToastProps[] = []

const flushPending = (instance: NotificationComponent) => {
  while (pendingMessages.length) {
    const props = pendingMessages.shift()!
    instance.add(props)
  }
}

const initToastHost = () => {
  NotificationComponent.newInstanced({}, (n) => {
    notificationInstance = n
    flushPending(n)
  })
}

const Toast = {
  toastMessage: (props: ToastProps) => {
    if (notificationInstance) {
      notificationInstance.add(props)
    } else {
      pendingMessages.push(props)
      if (pendingMessages.length === 1) {
        initToastHost()
      }
    }
  },
  closeToastMessage: (givenKey: string) => {
    if (notificationInstance) {
      notificationInstance.remove({ givenKey })
    }
  },
}

export default Toast
